import platformSingleton from '../../platform/platformSingleton';

import registerCard from '../../../common/cards/index';
import presentationalComponent from './Card';
import containerComponent from './CardContainer';

import { isPlatformApple } from '../../platform/utils/platformDetailsUtils';

import { ELEMENT_FEATURES } from '../feature/elementFeatureConstants';
import { TOOLBAR_TOOLS, TOOL_SETS } from '../../workspace/toolbar/config/toolbarToolConfig';
import { labelsFeaturePredicate } from '../labels/labelsUtils';

export default () =>
    registerCard({
        containerComponent,
        presentationalComponent,
        features: [ELEMENT_FEATURES.DOCUMENT, ELEMENT_FEATURES.DESCRIPTION, ELEMENT_FEATURES.TRANSPARENT],
        tooltip: isPlatformApple(platformSingleton) ? '⌃⌘N' : 'Ctrl+Alt+N',
        tools: {
            selected: [
                { ...TOOLBAR_TOOLS.COLOR, name: 'Card color', localeKey: 'tools.selected.cardColor' },
                TOOLBAR_TOOLS.REACTION,
                { ...TOOLBAR_TOOLS.LABEL, availabilityPredicate: labelsFeaturePredicate },
                TOOLBAR_TOOLS.COMMENT,
                ...TOOL_SETS.MULTI_SELECT_ARRANGEMENT,
            ],
            editing: TOOL_SETS.TEXT_EDITING_INLINE_AND_BLOCK,
        },
    });
